<template>
  <div class="table-responsive" v-if="this.$route.path == '/view-group-quote'">
    <table class="table">
      <thead>
        <tr>
          <th>Contact</th>
          <th>Group Details</th>
          <th>Group Plans</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td v-if="!groupLength" colspan="7" align="center">
            No records found.
          </td>
        </tr>
        <tr v-for="(employee, index) in groupCensusList.records"
          :class="`group-status-${employee.approval_status.toLowerCase()}`" :key="index">
          <td class="text-capitalize">
            <b>Group Name:</b> {{ employee.group_name }} <br />
            <b>Contact Name: </b> {{ employee.group_contact_name }}<br />
            <b>Contact Phone: </b> {{ employee.group_contact_phone | us_phone
            }}<br />
            <b>Contact Email:</b> {{ employee.group_contact_email }}<br />
          </td>
          <td class="text-capitalize">
            <b>Group Address:</b> {{ employee.group_address }}<br />
            <b>Group Start Date: </b>{{ employee.group_requested_start_date }}<br />
            <b>Number of Primary Applicant<span style="text-transform: lowercase;">(s)</span>:</b> {{
              employee.primary_count}}<br />
            <b>Number of Dependent<span style="text-transform: lowercase;">(s)</span>:</b> {{ employee.dependent_count
            }}<br />
            <b>Group Industry:</b> {{ employee.group_industry_title }}<br />
            <span class="badge group-quote-badge"   :class="`group-status-${employee.is_group_registered === 1 ? 'registered' : 'unregistered'}`">
              {{ employee.is_group_registered=== 1 ? 'Registered' : 'Unregistered' }}
            </span>
          </td>
          <td style="width: 15%;">
            <ul
              class="d-flex align-items-center "
              v-for="(plans, index) in employee.group_plans"
              :key="index"
            >
              <li>{{ plans.plan_name }}</li>
           
            </ul>
          </td>
          <td :class="`status-${employee.approval_status.toLowerCase()}`">
            {{ employee.approval_status }} 
          </td>
          <td>
            <custom-button class="group-action-icons" title="View Group Quote"
              @onClicked="openGroupDetailModel(employee)" iconClass="fas fa-user-friends" />
            <custom-button @onClicked="downloadGroupXls(employee)" class="group-action-icons"
              title="Download Group Quote" iconClass="fas fa-download" />
            <custom-button  v-if="checkGroupForRegistration(employee)&& !employee.is_group_registered" @onClicked="routeToGroupRegistration(employee)" class="group-action-icons"
              title="Group Registration" iconClass="fas fa-link" />
            <custom-button v-if="(employee.approval_status === 'APPROVED' && employee.approved_file_url)"
              @onClicked="downloadApprovedFiles(employee)" class="group-action-icons"
              title="Download Group Quote Approved File" iconClass="fas fa-file-pdf" />
          </td>
        </tr>
        <tr v-if="groupCensusList.length < 0">
          <td colspan="7" align="center">No records found.</td>
        </tr>
      </tbody>
    </table>
    <div>
      <group-detail-model :employeeInfo="employeeInfo" />
    </div>
  </div>

  <div class="table-responsive" v-else>
    <table class="table">
      <thead>
        <tr>
          <th>Group Details</th>
          <th>Group Plans</th>
          <th>Date</th>
          <th>Group Quote Total</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td v-if="!groupLength" colspan="7" align="center">
            No records found.
          </td>
        </tr>
        <tr
          v-for="(employee, index) in groupCensusList.records"
          :class="`group-status-${employee.approval_status.toLowerCase()}`"
          :key="index"
        >
          <!-- details -->
          <td>
            <b>Group Name: </b>
            <span class="text-capitalize">{{ employee.group_name }}</span
            ><br />
            <b>Contact Name: </b>
            <span class="text-capitalize">
              {{ employee.group_contact_name }} </span
            ><br />
            <b>Contact Phone:</b> {{ employee.group_contact_phone | us_phone
            }}<br />
            <b>Contact Email:</b> {{ employee.group_contact_email }}<br />
          </td>

          <!-- plans -->
          <td>

            <div v-if="employee.group_census_report.length > 0" class="member-list  member-scrollable-content">
              <div class="quote-member-card" v-for="(member, index) in employee.group_census_report" :key="index">
                <p> <span> {{ member.first_name + " " + member.last_name }} - <span class="member-plan-type">
                      {{ member.plan_type }}</span></span>

                  <span class="member-edit-btns">
                    <!-- <div class="group-action-icons">
                      <i class="fa-solid fa-pen"
                      @click="renderAddQuoteMemberModal(employee.id, employee.platform_name, 'update', member)" />
                    </div> -->

                    <!-- <custom-button v-if="employee.is_quote_clcked == 1" @onClicked="routeToGroupRegistration(employee)" class="group-action-icons"
                    title="Member Enrollment" iconClass="fas fa-link" /> -->


                    <div class="group-action-icons" v-if="employee.is_quote_clcked != 1" title="Delete Member">
                    <i class="fa-solid fa-trash" @click="openDeleteMemberModal(member.id)" />
                    </div>
                  </span>
                </p>  
                <ul v-if="member.plan_details && member.plan_details.length > 0" class="pt-3">
                  <li v-for="(plan, index) in member.plan_details" :key="index"> 
                    <p><span class="member-plan-name" :title="plan?.plan_name">{{ plan?.plan_name }}</span>  <span> ${{ plan?.plan_price }} </span></p>  
                  </li>
                </ul>
              </div>
            </div>
          </td>

          <!-- date and time -->
          <td>
            <div>
              <p class="mb-0 fw-bolder">Quote Created Date: </p>
              <p>{{ employee.created_at ? handleDateFormat(employee.created_at) : "N/A" }}</p>
            </div>
            <div>
              <p class="mb-0 fw-bolder">Quote Sent Date: </p>
              <p>{{ employee.sent_date ? handleDateFormat(employee.sent_date) : "N/A" }}</p>
            </div>
          </td>

          <td>
            {{ employee.group_quote_total && `$${employee.group_quote_total}` }}
          </td>

          <td :class="`status-${groupQuoteStatusClass(groupQuoteStatusMessage(employee.is_quote_clcked, employee.is_group_registered))}`">
            {{ groupQuoteStatusMessage(employee.is_quote_clcked, employee.is_group_registered) }}
          </td>
          <td class="ps-0">
            <custom-button class="group-action-icons" title="View Group Quote"
              @onClicked="openGroupDetailModel(employee)" iconClass="fas fa-user-friends" />
            <!-- <custom-button @onClicked="downloadGroupXls(employee)" class="group-action-icons"
              title="Download Group Quote" iconClass="fas fa-download" />
            <custom-button @onClicked="routeToGroupRegistration(employee)" class="group-action-icons"
              title="Group Registration" iconClass="fas fa-link" />
            <custom-button v-if="(employee.approval_status === 'APPROVED' && employee.approved_file_url)"
              @onClicked="downloadApprovedFiles(employee)" class="group-action-icons"
              title="Download Group Quote Approved File" iconClass="fas fa-file-pdf" /> -->

            <custom-button
              v-if="employee.is_quote_clcked != 1"
              class="group-action-icons"
              title="Add Member"
              iconClass="fas fa-plus"
              @onClicked="
                renderAddQuoteMemberModal(
                  employee.id,
                  employee.platform_name,
                  'add'
                )
              "
            />

            <custom-button
              class="group-action-icons"
              title="Send Quote"
              iconClass="fas fa-paper-plane"
              @onClicked="renderSendQuoteConfirmationModal(employee.id)"
v-if="hasMembersAndPlans(employee) && employee.is_quote_clcked != 1 && employee.status == 1"
            />
            <custom-button
              class="group-action-icons icon-delete-bg"
              title="Delete Quote"
              iconClass="fas fa-trash"
              v-b-modal.quoteDeleteModal
              @onClicked="setSelectedQuote(employee.id)"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <div>
      <group-detail-model :employeeInfo="employeeInfo" />
      <delete-group-member :id="currentMemberId" />
    </div>
    <!--add member modal-->
    <add-group-quote-member
      :groupCensusId="currentGroupCensusId"
      :currentGroupPlatform="currentEnrollmentPlatform"
      :actionType="memberAction"
      :memberToBeUpdated="memberDetails"
    />

    <!-- send Quote Modal -->
    <send-quote-confirmation :groupCensusId="currentGroupCensusId" />
    <quote-delete-modal  @deleteQuote="confirmDelete()" @closeDeleteModal="clearSelectedQuote()"/>
  </div>
</template>

<script>

import GroupListDetailModal from "../modal/GroupListDetailModal";
import AddGroupQuoteMember from "../../ViewQuotes/modal/PersonalizedGroupQuote/AddGroupQuoteMember.vue";
import DeleteGroupQuoteMember from "../modal/DeleteGroupQuoteMember.vue";
import SendQuoteConfirmation from "../modal/SendQuoteConfirmation.vue";
import QuoteDeleteModal from "../../ViewQuotes/modal/QuoteDeleteModal.vue";
import Api from "@/resource/Api";

export default {
  name: "GroupCensusTable",
  components: {
    "group-detail-model": GroupListDetailModal,
    "add-group-quote-member": AddGroupQuoteMember,
    "delete-group-member": DeleteGroupQuoteMember,
    "send-quote-confirmation": SendQuoteConfirmation,
    "quote-delete-modal": QuoteDeleteModal,
  },
  props: {
    groupCensusList: {
      type: Object,
    },
  },
  computed: {
    groupLength() {
      return this.groupCensusList?.records?.length > 0;
    },
    repInfo() {
      return this.$store.getters.rep;
    },
    memberAction() {
      return this.groupMemberSubmitAction;
    },
    memberDetails() {
      return this.memberToBeUpdated;
    },
  },
  data() {
    return {
      employeeInfo: {},
      currentGroupCensusId: "",
      currentEnrollmentPlatform: "",
      currentMemberId: "",
      groupMemberSubmitAction: "add",
      memberToBeUpdated: "",
      selected_quote_id: "",
    };
  },

  methods: {
    openGroupDetailModel(employee) {
      // let app = this;
      // app.employeeInfo = {};
      this.employeeInfo = employee;
      this.$bvModal.show("group-detail-view");
    },
    checkGroupForRegistration (employee) {
      let hasEmailInUse = employee.has_email_in_use
      let hasPhoneInUse = employee.has_phone_in_use
      let approvalStatus= employee.approval_status.toLowerCase()
      return ( hasEmailInUse === 0 && hasPhoneInUse=== 0 && approvalStatus=='approved');
    },
  
    downloadGroupXls(xls) {
      window.open(xls?.file_url, "_blank");
    },
    routeToGroupRegistration(employee) {
      let app = this;
      let groupCensusId = employee.id ? employee.id : null;
      const groupRegistrationLink =
        app.$endpoint.GROUP_APP_URL +
        `/registration?repCode=${app.repInfo.code}&groupCensusId=${groupCensusId}`;
      window.open(groupRegistrationLink, "_blank");
    },

    redirectMember(member){
      const id = member.id;
      const link = '' + id;
      window.open(link, "_blank");
    },

    downloadApprovedFiles(approveFile) {
      window.open(approveFile?.approved_file_url, "_blank");
    },

    openDeleteMemberModal(id) {
      this.currentMemberId = id;
      this.$bvModal.show("group-quote-member-delete");
    },

    hasMembersAndPlans(employee) {
      return employee.group_census_report.length > 0;
    },

    getPlanPricing(planPricingItem) {
      const pricingList = JSON.parse(planPricingItem);

      //return an array of plan pricing list
      if (Array.isArray(pricingList)) return pricingList;
      else return [pricingList];
    },

    //get formatted time
    handleTime(date) {
      const time = new Date(date);
      let hours = time.getHours();
      const minutes = String(time.getMinutes()).padStart(2, "0");
      const seconds = String(time.getSeconds()).padStart(2, "0");
      let meridian = "AM";

      if (hours >= 12) {
        if (hours > 12) hours -= 12;
        meridian = "PM";
      } else if (hours === 0) {
        hours = 12;
      }

      hours = String(hours).padStart(2, "0");
      return `${hours}:${minutes}:${seconds} ${meridian}`;
    },

    //get formatted date
    handleDateFormat(date) {
      const time = new Date(date);

      const month = String(time.getMonth() + 1).padStart(2, "0");
      const day = String(time.getDate()).padStart(2, "0");
      const year = time.getFullYear();

      return `${month}/${day}/${year}`;
    },

    renderAddQuoteMemberModal(id, platform, actionType, member) {
      this.currentGroupCensusId = id;
      this.currentEnrollmentPlatform = platform;

      if (actionType == "add") this.groupMemberSubmitAction = "add";
      if (actionType == "update") {
        this.groupMemberSubmitAction = "update";
        this.memberToBeUpdated = member;
      }

      this.$bvModal.show("group-quote-member-add");
    },

    renderSendQuoteConfirmationModal(id) {
      this.currentGroupCensusId = id;
      this.$bvModal.show("send-quote-confirmation");
    },

    groupQuoteStatusMessage(isQuoteClicked, isGroupRegistered){
      return isGroupRegistered? 'Approved' : isQuoteClicked == 1 ? 'Started' : isQuoteClicked == 0 ? 'Declined' : 'Not Started';
    },

    groupQuoteStatusClass(status){ 
      return status.toLowerCase() == "approved" ? "approved" : 
             status.toLowerCase() == "started" ? "started" :
             status.toLowerCase() == "declined" ? "declined" :
             "not-started"
    },
    clearSelectedQuote() {
      this.selected_quote_id = "";
    },
    setSelectedQuote(id) {
      this.selected_quote_id = id;
    },
    confirmDelete() {
      let url = `v2/quote/soft-delete-group`;
      let loader = this.$loading.show();
      Api.delete(url, {group_census_id: this.selected_quote_id})
        .then(() => {
          this.$notify("Quote Deleted Successfully", "success");
          this.clearSelectedQuote();
          this.$emit('reloadQuotes');
        })
        .catch(() => {
          this.$notify("Something went wrong. Please try again", "error");
        })
        .finally(() => {
          loader.hide();
        });
    },


  },
};
</script>
<style>
.group-action-icons .fa-user-friends{
  font-size: 12px ;
}
</style>
<style scoped>
.quote-member-card {
  background-color: rgba(243, 243, 243, 0.425);
  border: .1rem solid rgb(216, 216, 216);
  padding: 0.8rem;
  border-radius: .25rem;
}

.quote-member-card p {
  margin-bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.quote-member-card p span {
  margin-bottom: 0;
}

.member-edit-btns {
  display: flex;
  align-items: center;
}

.group-action-icons  .fa-solid.fa-pen{
  color: #fff;
  font-size: 12px;
}

.fa-solid {
  cursor: pointer;
}

.member-edit-btns .fa-trash {
  color: rgb(255, 255, 255);
  font-size: 10px;
}

.fa-pen {
  color: #008000;
}

.group-quote-badge{
  color: white;
  padding: 0.4rem 0.7rem;
  font-size: 0.75rem;
}
.group-quote-badge.group-status-registered{
  background-color: #3bb54a;
}

.group-quote-badge.group-status-unregistered{
  background-color: #f29423;
}

.quote-member-card p span:first-of-type {
  font-weight: bold;
}

.member-plan-type {
  font-weight: 500 !important;
}

.quote-member-card ul {
  padding-left: 0.85rem;
}

.quote-member-card ul li {
  font-size: 0.85rem;
  line-height: 1.1rem;
  font-weight: 500;
}

.quote-member-card ul li span:first-of-type {
  font-weight: 700;
}

.member-list {
  display: flex;
  flex-direction: column;
  gap: .25rem;
  max-height: 250px;
  overflow-y: scroll;
}
.group-action-icons:hover{
  color:#fff;
}

.status-approved{
  color: #3bb54a;
}

.status-started {
  color: #f29423;
}

.status-not-started{
  color: #ea584e
}

.member-plan-name{
  max-width: 25ch;
  white-space: nowrap; 
  overflow: hidden; 
  text-overflow: ellipsis; 
  display: inline-block; 
}

.member-scrollable-content {
      height: 200px;
      overflow-y: scroll; /* Enable vertical scrolling */
    }

    /* Scrollbar styles for WebKit browsers */
    .member-scrollable-content::-webkit-scrollbar {
      width: 12px;
    }

    .member-scrollable-content::-webkit-scrollbar-track {
      background: #03c3ec;
      border-radius: 10px;
    }

    .member-scrollable-content::-webkit-scrollbar-thumb {
      background-color: #03c3ec;
      border-radius: 10px;
      border: 3px solid #f1f1f1;
    }

    .member-scrollable-content::-webkit-scrollbar-thumb:hover {
      background: #555;
    }

    /* Firefox scrollbar */
    .member-scrollable-content {
      scrollbar-width: thin;
      scrollbar-color: #a9a9a9 #f1f1f1;
    }
  .icon-delete-bg,
.icon-delete-bg:hover {
  background: #dc3545 !important;
  color: #fff !important;
}
@media (max-width:1260px) {
  .member-list {
    max-height: 190px ;
  }
}
</style>